/**
 * Mg Theme — FAQ Modern tab switcher
 * © 2026 NAMY SOLUTIONS LLC – All Rights Reserved.
 *
 * Filters FAQ cards by category tab.
 * Markup: tabs have [data-faq-tab="category-handle"], cards have [data-faq-category].
 * A11y: WAI-ARIA tablist — roving tabindex + Arrow/Home/End keyboard nav, one
 * shared tabpanel (the cards row) whose content is filtered per tab.
 *
 * Idempotent: each section is wired once (dataset guard); re-runs on
 * shopify:section:load so the Theme Editor + dynamically added sections work.
 */
(function () {
  'use strict';

  function wire(section) {
    if (!section || section.dataset.faqModernInit) return;
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-faq-tab]'));
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-faq-category]'));
    var panel = section.querySelector('.mg-faq-modern__cards');
    if (!tabs.length || !cards.length) return;
    section.dataset.faqModernInit = '1';

    /* aria-controls wiring (one shared panel) */
    if (panel && !panel.id) panel.id = 'mg-faq-panel-' + (section.id || Math.round(section.getBoundingClientRect().top));
    if (panel) tabs.forEach(function (t) { t.setAttribute('aria-controls', panel.id); });

    function activate(tab, focus) {
      var target = tab.dataset.faqTab;
      tabs.forEach(function (t) {
        var isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.tabIndex = isActive ? 0 : -1; /* roving tabindex */
      });
      cards.forEach(function (card) {
        var cat = card.dataset.faqCategory || '';
        card.hidden = !(target === 'all' || cat === target);
      });
      if (focus) tab.focus();
    }

    tabs.forEach(function (tab, i) {
      /* initial roving tabindex from the server-rendered is-active state */
      tab.tabIndex = tab.classList.contains('is-active') ? 0 : -1;

      tab.addEventListener('click', function () { activate(tab, false); });

      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (e.key === 'Home') next = tabs[0];
        else if (e.key === 'End') next = tabs[tabs.length - 1];
        else return;
        e.preventDefault();
        activate(next, true);
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.mg-faq-modern').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme Editor: wire sections added/reloaded after first paint */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
